<template>
    <div id="viewer">
        <div class="inner">
            <div class="nav-next" v-on:click="selectNext()"></div>
            <div class="nav-previous" v-on:click="selectPrev()"></div>
            <div class="toggle"  v-on:click="toggle"></div>
        </div>

        <div class="slide active" v-if="img">
            <div class="caption">
                <h2>{{ img.title }}</h2>
                <div v-html="img.content"></div>
            </div>
            <div class="image" v-bind:style='{ backgroundImage: "url(" + img.imgix_url + ")", backgroundSize: "contain",  backgroundPosition: "center" }'>
            </div>
        </div> 
    </div>
</template>

<script>
    import {EventBus} from './event_bus';

    export default {
        name: 'viewer',
        created() {
            this.img = {'imgix_url': 'static/gallery/DSC_6067.jpg'};

            EventBus.$on('loaded', (obj) => {
                this.img = obj;
            });
        },
        data () {
            return {
                img: null
            }
        },
        methods: {
            selectNext() {
                EventBus.$emit('move', 1);
            },
            selectPrev() {
                EventBus.$emit('move', -1);
            },
            toggle() {
                console.log('io');
                if ( document.body.classList.contains('fullscreen'))
                    this.show();
                else
                    this.hide();
            },
            show() {
                // Already visible? Bail.
                if (!document.body.classList.contains('fullscreen'))
                    return;

                // Show main wrapper.
                document.body.classList.remove('fullscreen');

                // Focus.
                document.getElementById('main').focus();

            },

            /**
             * Hides the main wrapper.
             */
            hide: function() {

                // Already hidden? Bail.
                if (document.body.classList.contains('fullscreen'))
                    return;

                // Hide main wrapper.
                document.body.classList.add('fullscreen');

                // Blur.
                document.getElementById('main').blur();

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gallery/Viewer.vue?d0e7abde